export default __webpack_public_path__ + "static/media/profile_picture.6e6b1036.jpg";